import React, { Component } from 'react';
import './index.css'

import State from '../State'

class Info extends Component {
  handleCloseClick() {
    State.action('toggleInfo')
  }

  render() {
    if(!State.showInfo) {
      return null
    }

    let videoWidth = State.clientWidth * 0.5
    let videoHeight = videoWidth * 315 / 560

    return (
      <div className="info-inner">
        <h1>Brexplorer</h1>
        <div>Brexplorer is an interactive tool for exploring spending data during the UK&#8217;s EU refendum.</div>
        <iframe width={videoWidth} height={videoHeight} src="https://www.youtube.com/embed/arIv0WoBmgs?showinfo=0" frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen title="explainer-video"></iframe>
        <div>See anything interesting? Share your findings by sharing the URL from your browser&#8217;s address bar.</div>
        <div><a href="http://search.electoralcommission.org.uk/Search/Spending?currentPage=1&rows=10&sort=DateIncurred&order=desc&tab=1&open=filter&et=pp&et=ppm&et=tp&et=perpar&et=rd&evt=referendum&ev=2514&optCols=CampaigningName&optCols=ExpenseCategoryName&optCols=FullAddress&optCols=AmountInEngland&optCols=AmountInScotland&optCols=AmountInWales&optCols=AmountInNorthernIreland&optCols=DateOfClaimForPayment&optCols=DatePaid" target="_blank" rel="noopener noreferrer">Data</a> provided by the Electoral Commission. Design and build <a href="https://peterrcook.com" target="_blank" rel="noopener noreferrer">Peter Cook</a>.</div>
        <div className="close-button" onClick={this.handleCloseClick}>
          <svg width="24px" height="24px">
            <g className="close-icon" transform="translate(12, 12)scale(1.1)">
              <circle r="9" style={{fill: 'rgb(255, 255, 255)'}}></circle>
              <circle r="9" style={{fill: '#474842'}}></circle>
              <line x1="-3" y1="-3" x2="3" y2="3" style={{stroke: 'rgb(255, 255, 255)', strokeWidth: 3}}></line>
              <line x1="-3" y1="3" x2="3" y2="-3" style={{stroke: 'rgb(255, 255, 255)', strokeWidth: 3}}></line>
            </g>
          </svg>
        </div>
      </div>
    )
  }
}

export default Info



// WEBPACK FOOTER //
// ./src/Info/index.js